// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"29af45cf","498":"54a630a1","703":"46387786","787":"710200e9"}[chunkId] + ".chunk.js";
};